import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import './styles/Neo.css';
import { BrowserRouter } from "react-router-dom";
import { useState } from "react";

import { AuthProvider } from "./auth";
import { AppRouter } from "./router/AppRouter";
import { DownloadProvider } from "./data_layer/context/Download/DownloadProvider";
import { DownloadStatusBar } from "./components/Download/DownloadStatusBar";

function App() {

  const [token, setToken] = useState();

  return (
    <BrowserRouter>
      <AuthProvider>
        <DownloadProvider>
          <AppRouter setToken={setToken}/>
          <DownloadStatusBar />
        </DownloadProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App;
